import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TemplateType, TemplateTypeLabel } from './constants/constants';
import { throwError } from 'rxjs';
import { ElementRef } from '@angular/core';

export const rfqTemplateTypes = [
  {
    value: 'All',
    label: 'All',
  },
  {
    value: 'CapEx',
    label: 'Capital Equipment',
  },
  {
    value: 'Component',
    label: 'Component',
  },
  {
    value: 'InDirectMRO',
    label: 'Indirect MRO',
  },
  {
    value: 'Logistics',
    label: 'Logistics',
  },
  // {
    //   value: 'CommercialRefrigeration',
    //   label: 'Commercial Refrigeration',
    // },
    {
      value: 'Others',
      label: 'Others',
    },
    {
      value: 'Paint',
      label: 'Paint',
    },
    {
      value: 'RawMaterial',
      label: 'Raw Material',
    },
    {
      value: 'Tooling',
      label: 'Tooling',
    },
];

export const downloadAllRfqFiles = async (
  baseUrl: string,
  commonService: any,
  attachments: any[],
  toastr: ToastrService,
) => {
  if (attachments.length > 0) {
    for (const item of attachments) {
      await downloadFiles(baseUrl, commonService, toastr, item.id, item.fileName);
    }
    toastr.success(`All files downloaded successfully`);
  }
};

export const downloadFiles = async (
  baseUrl: string,
  commonService: any,
  toastr: ToastrService,
  id: number,
  fileName: string,
) => {
  let apiUrl: string = `${baseUrl}auth-service/file-management?id=${id}`;
  commonService.getData(apiUrl).subscribe({
    next: (data: any) => {
      let link = document?.createElement('a');
      link.href = data.response;
      link.download = fileName;
      link.target = '_blank';
      link.click();
    },
    error: (error: HttpErrorResponse) => {
      toastr.error(`Error while fetching the file from server`);
    },
  });
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) {
    return '0 Bytes';
  }
  const k = 1024;
  const dm = decimals <= 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const awsBasicUploadSingle = async (
  http: HttpClient,

  toastr: ToastrService,
  url: string,
  file: File,
) => {
  const HttpUploadOptions = {
    headers: new HttpHeaders({ 'Content-Type': file.type }),
  };
  http.put(url, file, HttpUploadOptions).subscribe({
    next: (data: any) => {
      toastr.success(`File uploaded successfully ${file.name}`);
    },
    error: (error: HttpErrorResponse) => {
      toastr.error(error.error.status.error.message);
    },
  });
};
export const downloadUserManual = async (
  baseUrl: string,
  commonService: any,
  toastr: ToastrService,
  fileName: string,
) => {
  let apiUrl: string = `${baseUrl}auth-service/file-management/sample-template?name=${fileName}`;
  commonService.getData(apiUrl).subscribe({
    next: (data: any) => {
      let link = document?.createElement('a');
      link.href = data.response;
      link.download = fileName;
      link.target = '_blank';
      link.click();
    },
    error: (error: HttpErrorResponse) => {
      toastr.error(`Error while fetching the file from server`);
    },
  });
};

export const checkFileNameLength = (
  fileName: string,
  maxLength: number,
  toastr: ToastrService,
): boolean => {
  const fileNameChars = fileName?.split('');
  if (fileNameChars.length > maxLength) {
    toastr.error(`File name should not exceed ${maxLength} characters`);
    return false;
  }
  return true;
};

/** Method to find minimum and maximum date from an array of dates */
export const getMinMaxDate = (dates: Date[], type: 'min' | 'max'): Date => {
  let date: Date = new Date();
  const validDates = dates.filter((date) => date).map((date) => new Date(date)); // to filter out null and undefined values

  if (type === 'min') date = new Date(Math.min(...(validDates as any)));
  else if (type === 'max') date = new Date(Math.max(...(validDates as any)));

  return date;
};

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const getCustomerToken = (): boolean => {
  let customerToken = localStorage.getItem('customerToken');
  if (customerToken) {
    return true;
  } else {
    return false;
  }
};

export const logOut = (
  entity: string,
  baseUrl: string,
  commonService: any,
  toastr: ToastrService,
  router: Router,
) => {
  const payload = {
    idToken: '',
  };
  let logoutUrl = '/';
  if (entity.includes('shop?') || entity.includes('/shop') || entity.includes('shop')) {
    entity = 'shop';
    logoutUrl = router.url;
  }

  switch (entity) {
    case 'customer':
      Object.assign(payload, {
        accessToken: localStorage.getItem('customerAccessToken'),
        refreshToken: localStorage.getItem('customerRefreshToken'),
      });
      break;
    case 'supplier':
      Object.assign(payload, {
        accessToken: localStorage.getItem('supplierAccessToken'),
        refreshToken: localStorage.getItem('supplierRefreshToken'),
      });
      break;
    case 'shop':
      Object.assign(payload, {
        accessToken: localStorage.getItem('customerAccessToken'),
        refreshToken: localStorage.getItem('customerRefreshToken'),
      });
      logoutUrl = '/shop';
      break;
    default:
      Object.assign(payload, {
        accessToken: localStorage.getItem('internalAccessToken'),
        refreshToken: localStorage.getItem('internalRefreshToken'),
      });
  }
  const apiURL = `${baseUrl}auth-service/logout`;
  commonService.postDatawithoutHeaders(apiURL, payload).subscribe({
    next: (res: any) => {
      toastr.success('Logout Successfully');
      removeKeys(entity, router);
      commonService.setData('logout');
    },
    error: (error: HttpErrorResponse) => {
      if (error.error?.status?.error?.message) {
        toastr.error(error.error.status.error.message);
      }
    },
  });
};

export const getRFQTemplateLabel = (rfqType: TemplateType) => {
  if (rfqType) {
    const label = TemplateTypeLabel[rfqType];
    return label;
  }
  return '';
};

export const removeKeys = (entity: string, router: Router) => {
  const localStorageKeys: { [key: string]: string[] } = {
    customer: [
      'customeruserId',
      'customerToken',
      'customerUserName',
      'customerpermissionsData',
      'customercompanyId',
      'customerRefreshToken',
      'customerAccessToken',
      'customeremail',
      'preEmail',
      'customerRole',
    ],
    supplier: [
      'supplieruserId',
      'supplierToken',
      'supplierpermissionsData',
      'supplierid',
      'supplierUserName',
      'supplieremailId',
      'supplierRefreshToken',
      'supplierAccessToken',
      'preEmail',
      'supplierRole',
    ],
    internal: [
      'adminemailId',
      'adminuserId',
      'adminpermissionsData',
      'internalToken',
      'adminUserName',
      'internalAccessToken',
      'internalRefreshToken',
      'adminRole',
    ],
    shop: [
      'customeruserId',
      'customerToken',
      'customerUserName',
      'customerpermissionsData',
      'customercompanyId',
      'customerRefreshToken',
      'customerAccessToken',
      'customer-company-profile',
      'adminUserName',
    ],
  };
  let logoutUrl = '/';

  if (entity.includes('shop?') || entity.includes('/shop') || entity.includes('shop')) {
    entity = 'shop';
    logoutUrl = router.url;
  }
  const keysToRemove = localStorageKeys[entity];
  if (keysToRemove) {
    keysToRemove.forEach((key: any) => localStorage.removeItem(key));
  }
  router.navigateByUrl(logoutUrl);
};
export const getValidationParseError = (templateType: string, fileType: string) => {
  let description = '';
  let heading = '';
  if (fileType === 'Quote') {
    heading = `Errors found in ${templateType} Quote file, kindly check and upload the file again.`;
    description =
      'The uploaded quote file has errors. Kindly check the downloaded quote excel file and rectify the errors in highlighted cells/ error worksheet, and upload the file again.';
  } else {
    heading = `Errors found in ${templateType} RFQ file, kindly check and upload the file again.`;
    description =
      'The uploaded RFQ file has errors. Kindly check the downloaded RFQ excel file and rectify the errors in highlighted cells/ error worksheet, and upload the file again.';
  }
  let errorObj = {
    heading: heading,
    text: description,
  };
  return errorObj;
};
export const handleApiError = (error: HttpErrorResponse) => {
  if (error.status === 0) {
    console.error('An error occurred:', error.error);
  } else {
    console.error(`Backend returned code ${error.status}, body was: `, error.error);
  }

  return throwError(() => new Error('Something bad happened; please try again later.'));
};

export const isLocalEnv = (): boolean => {
  if (window.location.host == 'localhost:4200') {
    return true;
  }
  return false;
};

export const isDevEnv = (): boolean => {
  if (window.location.host == 'dev.unibuild.ai' || window.location.host == 'ml-dev.unibuild.ai') {
    return true;
  }
  return false;
};

export const isTestEnv = (): boolean => {
  if (window.location.host == 'test.unibuild.ai') {
    return true;
  }
  return false;
};

export const isDemoEnv = (): boolean => {
  if (window.location.host == 'demo.unibuild.ai') {
    return true;
  }
  return false;
};

export let SHOP_BASE_URL = '';
if (isDevEnv()) {
  SHOP_BASE_URL = 'https://develop-shop.unibuild.ai/api/';
} else {
  SHOP_BASE_URL = 'https://shop.unibuild.ai/api/';
}

declare var AwsWafCaptcha: any;
export const getCaptcha = (captchaContainer: ElementRef, apiKey: string): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    AwsWafCaptcha.renderCaptcha(captchaContainer, {
      containerId: 'aws-waf-captcha',
      apiKey: apiKey,
      onSuccess: (result: any) => {
        resolve(true);
      },
      onError: (result: any) => {
        resolve(false);
      },
      dynamicWidth: true, 
      skipTitle: true,
      disableLanguageSelector: true
      // ...other configuration parameters as needed...
    });
  });
}